<template>
<!-- 忘记密码 -->
  <div class="container">
    <!-- 页面头部 -->
    <div class="head">
      <img class="logo" src="@/assets/logo1.png" alt="">
    </div>
    <div class="title">找回密码</div>
    <!-- 页面内容 -->
    <div class="content">
      <div class="form-content">
          <div class="form">
              <div class="input">
                  <input v-model="params.phone" type="text" placeholder="请输入手机号">
              </div>
              <div class="input">
                  <input v-model="params.captcha" type="text" placeholder="请输入短信验证码">
                  <div class="code pointer" @click="getCode" v-if="!time">获取验证码</div>
                  <div class="code pointer grey" @click="getCode" v-else>{{time}}s后重新获取</div>
              </div>
              <div class="input">
                  <input v-model="params.password" v-if="!password_open" type="password" placeholder="请输入密码">
                  <input v-model="params.password" v-else type="text" placeholder="请输入密码">
                  <img class="pointer" v-if="!password_open" src="@/assets/biyan.png" @click="password_open=true">
                  <img class="pointer" v-else src="@/assets/zhengyan.png" @click="password_open=false">
              </div>
              <div class="input">
                  <input v-model="confirm_password" v-if="!confirm_show" type="password" placeholder="请确认密码">
                  <input v-model="confirm_password" v-else type="text" placeholder="请确认密码">
                  <img class="pointer" v-if="!confirm_show" src="@/assets/biyan.png" @click="confirm_show=!confirm_show">
                  <img class="pointer" v-else src="@/assets/zhengyan.png" @click="confirm_show=!confirm_show">
              </div>
              <div class="btn pointer" @click="loginClick">登录</div>
              <div class="back pointer" @click="backClick">返回登录</div>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import Header from '../../components/Header.vue'
export default {
  name: 'forget',
  components:{Header},
  data(){
    return{
      params:{
        "password": '',
        "captcha": '',
        "phone": '',
      },
      confirm_password:'',
      time:0,
      password_open:false,
      confirm_show:false
    }
  },
  activated(){

  },
  methods:{
    // 点击返回登录
    backClick(){
      this.$router.back(-1)
    },
    // 点击登录
    async loginClick(){
      if(!this.params.phone){
        this.$message({message: '请输入手机号', duration:1000});
        return
      }else if(!this.params.captcha){
        this.$message({message: '请输入短信验证码', duration:1000});
        return
      }else if(!this.params.password){
        this.$message({message: '请输入密码', duration:1000});
        return
      }else if(this.params.password != this.confirm_password){
        this.$message({message: '请输入两次输入密码不符', duration:1000});
        return
      }

      let res = await this.$req({
        url:`/user/forget/forgetPasswordByPhone`,
        api:'/mng',
        method:'POST',
        data:this.params
      })
      if(res.code==200){
        this.$message({
          message: '密码已修改，请重新登录',
          type: 'success'
          , duration:1000
        });
        this.$router.replace('login')
      }else{
        this.$message({
          message: res.msg
          , duration:1000
        });
      }
    },
    // 获取手机验证码
    async getCode(){
      if(!this.params.phone){
        this.$message({message: '请输入手机号', duration:1000});
        return
      }
      
      let res = await this.$req({
        url:`/common/smsRetrievePassword/${this.params.phone}`,
        api:'/mng',
        method:'POST'
      })
      if(res.code==200){
        this.time = 60
        this.timer = setInterval(() => {
          if(this.time > 0){
            this.time --
          }else{
            clearInterval(this.timer)
          }
        }, 1000);
        this.$message({
          message: '发送成功',
          type: 'success'
          , duration:1000
        });
      }
    },
  }
}
</script>

<style scoped lang="stylus">
.container
  height: 100vh
  width: 100vw
  overflow: hidden
  position relative
  padding-top: 0
  // 头部
  .head
    width 100%
    height: 70px;
    background: #015DE7;
    padding: 15px 18px
    position relative
    z-index 2
    .logo
        width 150px
        height 50px
  .form
    .input
      border-bottom: 1px solid #E6E8F2
      height 48px
      margin-bottom: 20px
      position relative
      input
        font-size: 16px
        width 100%
        border: none
        outline: none
        height: 100%
      .code,img
        color: #015DE7
        font-size: 16px;
        position: absolute
        right: 0
        top 50%
        transform: translateY(-50%)
      .grey
        color: rgba(16, 29, 55, .3);
      img
        width 16px
        height 16px
        padding: 16px
        box-sizing: content-box
        z-index: 999
    .btn
      height: 44px;
      border-radius: 2px;
      background-color: rgba(1, 93, 231, 1);
      line-height: 44px
      text-align: center
      font-size: 16px
      color: #fff
      margin-top: 32px
    .back
      font-size: 12px
      line-height: 20px
      text-align: center
      margin-top: 20px
</style>
